'use client';

import merge from 'lodash/merge';
import { hi as hiINAdapter, enUS as enUSAdapter } from 'date-fns/locale';

import { enUS as enUSDataGrid } from '@mui/x-data-grid';
import { enUS as enUSDate } from '@mui/x-date-pickers/locales';
import { enUS as enUSCore, hiIN as hiINCore } from '@mui/material/locale';

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
  },
  {
    label: 'Hindi',
    value: 'hi',
    systemValue: merge(enUSDataGrid, hiINCore),
    adapterLocale: hiINAdapter,
    icon: 'flagpack:in',
  },
];
export const defaultLang = allLangs[0];
